import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { handleError, handleSuccess } from '../utils';
import AppButton from '../components/AppButton';

function Login() {
    const [loginInfo, setLoginInfo] = useState({
        email: '',
        password: ''
    });
    const [showResend, setShowResend] = useState(false);
    const [verificationEmail, setVerificationEmail] = useState('');

    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setLoginInfo((prev) => ({ ...prev, [name]: value }));
    };

    const handleResendVerification = async () => {
        try {
            const url = `${process.env.REACT_APP_API_URL}/auth/resend-verification`;
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ email: verificationEmail || loginInfo.email })
            });

            const result = await response.json();
            if (result.success) {
                handleSuccess(result.message);
                setShowResend(false);
            } else {
                handleError(result.message);
            }
        } catch (err) {
            handleError(err.message || 'Unable to resend verification email');
        }
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        const { email, password } = loginInfo;
        if (!email || !password) {
            return handleError('Email and password are required');
        }
        try {
            const url = `${process.env.REACT_APP_API_URL}/auth/login`;
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(loginInfo)
            });
            const result = await response.json();
            const { success, message, jwtToken, name, error, requiresVerification } = result;
            if (success) {
                handleSuccess(message);
                localStorage.setItem('token', jwtToken);
                localStorage.setItem('loggedInUser', name);
                setTimeout(() => {
                    navigate('/home');
                }, 1000);
            } else if (error) {
                const details = error?.details?.[0]?.message;
                handleError(details || message);
            } else if (requiresVerification) {
                setVerificationEmail(result.email || email);
                setShowResend(true);
                handleError(message);
            } else {
                handleError(message);
            }
        } catch (err) {
            handleError(err.message || 'Unable to login');
        }
    };

    return (
        <div className='container'>
            <h1>Login</h1>
            <form onSubmit={handleLogin}>
                <div>
                    <label htmlFor='email'>Email</label>
                    <input
                        onChange={handleChange}
                        type='email'
                        name='email'
                        placeholder='Enter your email...'
                        value={loginInfo.email}
                    />
                </div>
                <div>
                    <label htmlFor='password'>Password</label>
                    <input
                        onChange={handleChange}
                        type='password'
                        name='password'
                        placeholder='Enter your password...'
                        value={loginInfo.password}
                    />
                </div>
                <AppButton type='submit'>Login</AppButton>
                <span>Doesn't have an account? <Link to="/signup">Signup</Link></span>
            </form>
            {showResend && (
                <div style={{ marginTop: '16px' }}>
                    <p>Your email is not verified yet.</p>
                    <AppButton type='button' onClick={handleResendVerification}>Resend verification email</AppButton>
                </div>
            )}
            <ToastContainer />
        </div>
    );
}

export default Login;
